export const dataSources = {
  trafa: {
    name: 'Trafikanalys',
    url: 'https://www.trafa.se/',
  },
  energimarknadsinspektionen: {
    name: 'Energimarknadsinspektionen',
    url: 'https://energi.maps.arcgis.com/apps/MapJournal/index.html?appid=a16ee2d3041843c38cb292f9f7649ad3',
  },
  tankaGront: {
    name: 'Tanka Grönt',
    url: 'https://www.tankagront.se/',
  },
  energimyndigheten: {
    name: 'Energimyndigheten',
    url: 'https://www.energimyndigheten.se/klimat--miljo/transporter/laddinfrastruktur/stod-att-soka-inom-laddinfrastruktur/regionala-elektrifieringspiloter/',
  },
  uppladdning: {
    name: 'Charging sites © zapup.eu',
    url: 'http://zapup.eu/',
  },
  nobil: {
    name: 'Nobil',
    url: 'https://nobil.no/',
  },
  vti: {
    name: 'Statens väg- och transportforskningsinstitut',
    url: '/fordonsprognos',
  },
  scb: {
    name: 'statistiska centralbyrån',
    url: 'https://www.scb.se',
  },
  trafikverket: {
    name: 'Trafikverket',
    url: 'https://bransch.trafikverket.se/tjanster/ansok-om/ansok-om-bidrag/ansok-om-bidrag-till-snabbladdningsstationer-for-elfordon/',
  },
  klimatklivet: {
    name: 'Naturvårdsverket',
    url: 'https://www.naturvardsverket.se/amnesomraden/klimatomstallningen/klimatklivet/',
  },
  biofuelExpress: {
    name: 'Biofuel Express',
    url: 'https://biofuel-express.se/',
  },
  energigasSverige: {
    name: 'Energigas Sverige',
    url: 'https://www.energigas.se/',
  },
}

export function getSource(sourceId: keyof typeof dataSources, year?: number) {
  const source = dataSources[sourceId]
  if (!source) {
    return null
  }
  return {
    ...source,
    name: `${source.name}${year ? ` (${year})` : ''}`,
  }
}
export type DataSource = ReturnType<typeof getSource>
export type DataSourceParams = {
  identifier: keyof typeof dataSources
  year?: number
}